import { useEffect } from "react"
import { _single, _WorkActivityType } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import useModal, {  MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal"
import { toast } from "react-toastify"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable"
import { Modal } from "../../theme/Component/Modal"
import { ModalConfirm } from "../../theme/Component/ModalConfirm"

export const WorkActivityType = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityType)

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar tipo de Actividad", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getWorkActivityTypeCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar los tipos de actividades");
        });
    };

    const create = () => {
        setBean({
            State: 1,
        });
        modal.open("Agregar Tipo de Actividades")
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivityType(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityType', visible: true },
        { title: 'Nombre', property: 'WorkActivityTypeName', visible: true },
        { title: 'Descripción', property: 'WorkActivityTypeDescription', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar tipo ${bean.WorkActivityTypeName}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipos de Actividad">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre del tipo de actividad</label>
                                <input type="text" className="form-control" value={bean.WorkActivityTypeName} onChange={(e) => { setBean({ ...bean, WorkActivityTypeName: e.target.value }) }} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción del tipo de Actividad</label>
                                <textarea className="form-control" value={bean.WorkActivityTypeDescription} onChange={(e) => { setBean({ ...bean, WorkActivityTypeDescription: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.WorkActivityTypeName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}